import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Whether modal dialogs should use MUI's responsive full-screen pattern.
 * Matches viewport `sm` and below (`theme.breakpoints.down('sm')`).
 * @returns `true` when the dialog should render full screen.
 */
export function useDialogFullScreen(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
}
